//LIBRERIE
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faMobileButton } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";

// STILI
import heroCarouselStyle from "../../assets/jsStyle/heroCarouselStyle";

const AboutUsMain: React.FC = () => {

    const { t } = useTranslation();

    return (
        <div className="row align-items-center">
            <div className="col-12 col-lg-8 mb-3 mb-lg-0">
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }}></p>
                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }}></p>
                <p className="mb-1" dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }}></p>
                <div>
                    <a className="d-inline-block" href="mailto:direzione@immobiliarenexa.it" target="_blank">
                        <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
                        direzione@immobiliarenexa.it
                    </a>
                </div>
                <div>
                    <a className="d-inline-block" href="https://api.whatsapp.com/send?phone=+393343829957" target="_blank">
                        <FontAwesomeIcon icon={faMobileButton} className="mr-2" />
                        +39 3343829957
                    </a>
                </div>
            </div>
            <div className="col-12 col-lg-4">
                <Slider {...heroCarouselStyle}>
                    <img src="/assets/images/altrePag/aboutUs1.webp" alt={t('aboutUsPage.image1Alt') as string} />
                    <img src="/assets/images/altrePag/aboutUs2.webp" alt={t('aboutUsPage.image2Alt') as string} />
                    <img src="/assets/images/altrePag/aboutUs3.webp" alt={t('aboutUsPage.image3Alt') as string} />
                    <img src="/assets/images/altrePag/aboutUs4.webp" alt={t('aboutUsPage.image4Alt') as string} />
                </Slider>
            </div>
        </div>
    )
};
export default AboutUsMain;